import Vue from 'vue'
import { pendencia as routing } from '../util/routes'

export default {
  state: {
    pendencias: {},
    onlyTecnico: true
  },
  mutations: {
    setDashboardData: (state, payload) => {
      state.pendencias = (payload) || Object.assign({}, {})
    },
    toggleOnlyTecnico: (state, payload) => {
      state.onlyTecnico = !state.onlyTecnico
    }
  },
  actions: {
    async getDashboardData ({ commit, state }) {
      commit('setDashboardData')
      const response = await Vue.axios.post(
        `${routing}`,
        {
          tecnico: state.onlyTecnico
        }
      )
      commit('setDashboardData', response.data)
    }
  },
  getters: {
    pendencias: ({ pendencias }) => pendencias,
    onlyTecnico: ({ onlyTecnico }) => onlyTecnico
  }
}
